var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Prop, Component } from 'vue-property-decorator';
import IconSpeedioSpinner from '@/components/Icons/IconSpeedioSpinner.vue';
let InnerLoading = class InnerLoading extends Vue {
    /** Mapeia as classes de tamanho antigas para valores CSS diretos */
    get spinnerSize() {
        const sizeMap = {
            'sp-sm': '24px',
            'sp-md': '32px',
            'sp-lg': '38px',
            'sp-xl': '46px',
            'sp-extra-xl': '92px',
        };
        return sizeMap[this.iconWidth] || '92px';
    }
};
__decorate([
    Prop({ default: '' })
], InnerLoading.prototype, "loadingMessage", void 0);
__decorate([
    Prop({ default: false })
], InnerLoading.prototype, "loading", void 0);
__decorate([
    Prop({ default: false })
], InnerLoading.prototype, "timeMessage", void 0);
__decorate([
    Prop({ default: 'sp-extra-xl' })
], InnerLoading.prototype, "iconWidth", void 0);
InnerLoading = __decorate([
    Component({
        components: {
            IconSpeedioSpinner,
        },
    })
], InnerLoading);
export default InnerLoading;
